import AiInterviewIcon from 'assets/icons/ai_interview.svg?react';
import AnalyticsIcon from 'assets/icons/analytics.svg?react';
import ChevronIcon from 'assets/icons/chevron.svg?react';
import ClapsIcon from 'assets/icons/claps.svg?react';
import CheckIcon from 'assets/icons/check.svg?react';
import ZoomInIcon from 'assets/icons/zoom_in.svg?react';
import CloseIcon from 'assets/icons/close.svg?react';
import CompletedIcon from 'assets/icons/completed.svg?react';
import DeniedIcon from 'assets/icons/denied.svg?react';
import EmptyDrawerIcon from 'assets/icons/empty-drawer.svg?react';
import GreenCheckIcon from 'assets/icons/green-check.svg?react';
import ArrowIcon from 'assets/icons/ic_arrow.svg?react';
import BrainIcon from 'assets/icons/ic_brain.svg?react';
import CogIcon from 'assets/icons/ic_cog.svg?react';
import FlameIcon from 'assets/icons/ic_flame.svg?react';
import LanguageIcon from 'assets/icons/ic_language.svg?react';
import MicrophoneIcon from 'assets/icons/ic_microphone.svg?react';
import PerformanceIcon from 'assets/icons/ic_performance.svg?react';
import PersonIcon from 'assets/icons/ic_person.svg?react';
import SignalCellularIcon from 'assets/icons/ic_signal_cellular.svg?react';
import TimeIcon from 'assets/icons/ic_time.svg?react';
import TwoSideArrowIcon from 'assets/icons/id_two_side_arrow.svg?react';
import InfoIIcon from 'assets/icons/info-i.svg?react';
import LeftArrowIcon from 'assets/icons/left_arrow.svg?react';
import LinkIcon from 'assets/icons/link.svg?react';
import ListIcon from 'assets/icons/list_alt.svg?react';
import ClapsLargeIcon from 'assets/icons/new-claps.svg?react';
import PlusIcon from 'assets/icons/plus.svg?react';
import GeneralQuestions from 'assets/icons/questions.svg?react';
import RightArrowIcon from 'assets/icons/right_arrow_green.svg?react';
import SettingsIcon from 'assets/icons/settings.svg?react';
import SortIcon from 'assets/icons/sort.svg?react';
import TagIcon from 'assets/icons/tag.svg?react';
import WarningIcon from 'assets/icons/Warning.svg?react';
import CognitiveTestIcon from 'assets/icons/test/cognitive.svg?react';
import DeiTestIcon from 'assets/icons/test/dei.svg?react';
import InductiveTestIcon from 'assets/icons/test/inductive.svg?react';
import NumericalTestIcon from 'assets/icons/test/numerical.svg?react';
import PersonalityTestIcon from 'assets/icons/test/personality.svg?react';
import SkillsTestIcon from 'assets/icons/test/skills_self_assessment.svg?react';
import VerbalTestIcon from 'assets/icons/test/verbal.svg?react';
import SignalWifiOffIcon from 'assets/icons/signal_wifi_off.svg?react';
import Sparkles from 'assets/icons/sparkles.svg?react';
import WifiOutline from 'assets/icons/wifi_outline.svg?react';
import CameraOutline from 'assets/icons/camera_outline.svg?react';
import CameraDisabled from 'assets/icons/camera_disabled.svg?react';
import MicDisabled from 'assets/icons/mic_disabled.svg?react';

import { FC, SVGAttributes } from 'react';

const iconsObj = {
  ai_interview: AiInterviewIcon,
  analytics: AnalyticsIcon,
  questions: GeneralQuestions,
  performance: PerformanceIcon,
  time: TimeIcon,
  arrow: ArrowIcon,
  completed: CompletedIcon,
  right_arrow: RightArrowIcon,
  left_arrow: LeftArrowIcon,
  cognitive_test: CognitiveTestIcon,
  inductive_test: InductiveTestIcon,
  numerical_test: NumericalTestIcon,
  personality_test: PersonalityTestIcon,
  verbal_test: VerbalTestIcon,
  dei: DeiTestIcon,
  skills_self_assessment: SkillsTestIcon,
  brain: BrainIcon,
  chevron: ChevronIcon,
  list: ListIcon,
  flame: FlameIcon,
  claps: ClapsIcon,
  plus: PlusIcon,
  cog: CogIcon,
  language: LanguageIcon,
  info_i: InfoIIcon,
  person: PersonIcon,
  empty_drawer: EmptyDrawerIcon,
  settings: SettingsIcon,
  sort: SortIcon,
  claps_large: ClapsLargeIcon,
  tag: TagIcon,
  link: LinkIcon,
  green_check: GreenCheckIcon,
  check: CheckIcon,
  zoom_in: ZoomInIcon,
  microphone: MicrophoneIcon,
  denied: DeniedIcon,
  two_side_arrow: TwoSideArrowIcon,
  close: CloseIcon,
  warning: WarningIcon,
  signal_cellular: SignalCellularIcon,
  signal_wifi_off: SignalWifiOffIcon,
  sparkles: Sparkles,
  camera_outline: CameraOutline,
  wifi_outline: WifiOutline,
  camera_disabled: CameraDisabled,
  mic_disabled: MicDisabled,
};

export type IconType = keyof typeof iconsObj;

interface IconProps extends SVGAttributes<SVGSVGElement> {
  icon: IconType;
  className?: string;
  title?: string;
  alt?: string;
}

const Icon: FC<IconProps> = ({ icon, className, ...rest }) => {
  const Component = iconsObj[icon];

  return iconsObj[icon] ? <Component className={className} {...rest} /> : null;
};

export default Icon;
